import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Curriculum from '@/components/Curriculum'
import CurriculumDetail from '@/components/view/Curriculums/curriculumDetail'
import Course from '@/components/Course'
import CourseClasses from '@/components/CourseClasses'
import Agreement from '@/components/Agreement'
import UserAgreement from '@/components/UserAgreement'
import Statement from '@/components/Statement'
import Activity from '@/components/Activity'
import ActivityDetail from '@/components/ActivityDetail'
import Task from '@/components/Task'
import TaskDetail from '@/components/TaskDetail'
import About from '@/components/About'
import Circle from '@/components/Circle'
import Login from '@/components/Login'
import LoginSuccess from '@/components/LoginSuccess'
import Personal from '@/components/Personal'
import PersonalEdit from '@/components/PersonalEdit'
import CircleDetails from '@/components/CircleDetails'
import Publishlist from '@/components/Publishlist'
import Publishneiru from '@/components/Publishneiru'
import CurriculumDetails from '@/components/CurriculumDetails' //回放页面
import CurriculumDetailslive from '@/components/CurriculumDetailslive' // 体验课 直播页
import ClassesLive from '@/components/ClassesLive' // 正式课 直播页
import NewsDetails from '@/components/NewsDetails'
import CourseDetails from '@/components/CourseDetails'
import Search from '@/components/search'
import Tool from '@/components/Tool'
import ToolDetail from '@/components/ToolDetail'
import Demo from '@/components/Demo'
import Ai from '@/components/Ai'
import {
  getCookie
} from '@/utils/auth.js'
// Vue.prototype.$cookieStore = {setCookie, getCookie, delCookie}


const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// 创建一个路由器
const router1 = new Router({
  routes: [{
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        // isAuth: true,
        title: '美课教育-不仅是专业课堂，更是艺术人生'
      }
    },{
      path: '/ai',
      name: 'Ai',
      component: Ai,
      meta: {
        // isAuth: true,
        title: 'AI体验-美课教育'
      }
    },
    {
      path: '/curriculum',
      name: 'Curriculum',
      component: Curriculum,
      meta: {
        // isAuth: true,
        title: '正式课-美课教育'
      }
    },
    {
      path: '/curriculumDetail',
      name: 'CurriculumDetail',
      component: CurriculumDetail
    },
    {
      path: '/course',
      name: 'Course',
      component: Course,
      meta: {
        // isAuth: true,
        title: '教程区-美课教育'
      }
    },
    {
      path: '/Publishlist',
      name: 'Publishlist',
      component: Publishlist,
      meta: {
        // isAuth: true,
        title: '我的作业-美课教育'
      }
    },
    {
      path: '/Publishneiru',
      name: 'Publishneiru',
      component: Publishneiru,
      meta: {
        // isAuth: true,
        title: '作业详情-美课教育'
      }
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: Agreement,
      meta: {
        // isAuth: true,
        title: '服务协议-美课教育'
      }
    },
    {
      path: '/useragreement',
      name: 'UserAgreement',
      component: UserAgreement,
      meta: {
        // isAuth: true,
        title: '用户协议-美课教育'
      }
    },
    {
      path: '/statement',
      name: 'Statement',
      component: Statement,
      meta: {
        // isAuth: true,
        title: '用户协议-美课教育'
      }
    },
    {
      path: '/activity',
      name: 'Activity',
      component: Activity,
      meta: {
        // isAuth: true,
        title: '美课活动-美课教育'
      }
    },
    {
      path: '/activitydetail',
      name: 'ActivityDetail',
      component: ActivityDetail,
      meta: {
        // isAuth: true,
        title: '活动详情-美课教育'
      }
    },
    {
      path: '/tool',
      name: 'Tool',
      component: Tool,
      meta: {
        // isAuth: true,
        title: '资源库-美课教育'
      }
    },
    {
      path: '/tooldetail',
      name: 'ToolDetail',
      component: ToolDetail,
      meta: {
        // isAuth: true,
        title: '美课资源库-美课教育'
      }
    },
    {
      path: '/task',
      name: 'Task',
      component: Task,
      meta: {
        // isAuth: true,
        title: '美课兼职中心-美课教育'
      }
    },{
      path: '/taskdetail',
      name: 'TaskDetail',
      component: TaskDetail,
      meta: {
        // isAuth: true,
        title: '美课兼职详情-美课教育'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        // isAuth: true,
        title: '关于美课-美课教育'
      }
    },
    {
      path: '/circle',
      name: 'Circle',
      component: Circle,
      meta: {
        // isAuth: true,
        title: '美课社区-美课教育'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        // isAuth: false,
        title: '登录-美课教育'
      }
    },{
      path: '/loginsuccess',
      name: 'LoginSuccess',
      component: LoginSuccess,
      meta: {
        // isAuth: false,
        title: '微信登录-美课教育'
      }
    },
    {
      path: '/personal',
      name: 'Personal',
      component: Personal,
      meta: {
        // isAuth: true,
        title: '个人中心-美课教育'
      }
    },
    {
      path: '/courseclasses',
      name: 'CourseClasses',
      component: CourseClasses,
      meta: {
        // isAuth: true,
        title: '我的课程详情-美课教育'
      }
    },
    {
      path: '/PersonalEdit',
      name: 'PersonalEdit',
      component: PersonalEdit,
      meta: {
        // isAuth: true,
        title: '个人资料-美课教育'
      }
    },
    {
      path: '/Search',
      name: 'Search',
      component: Search,
      meta: {
        // isAuth: true,
        title: '搜索-美课教育'
      }
    },
    {
      path: '/CircleDetails',
      name: 'CircleDetails',
      component: CircleDetails,
      meta: {
        // isAuth: true,
        title: '详情页-美课教育'
      }
    },
    {
      path: '/live',
      name: 'CurriculumDetailslive',
      component: CurriculumDetailslive,
      meta: {
        // isAuth: true,
        title: '美课体验课-美课教育'
      }
    },
    {
      path: '/NewsDetails',
      name: 'NewsDetails',
      component: NewsDetails,
      meta: {
        // isAuth: true,
        title: '新闻详情页-美课教育'
      }
    },
    {
      path: '/CourseDetails',
      name: 'CourseDetails',
      component: CourseDetails,
      meta: {
        // isAuth: true,
        title: '教程详情页-美课教育'
      }
    },
    {
      path: '/CurriculumDetails',
      name: 'CurriculumDetails',
      component: CurriculumDetails,
      meta: {
        // isAuth: true,
        title: '课程详情-美课教育'
      }
    },
    {
      path: '/ClassesLive',
      name: 'ClassesLive',
      component: ClassesLive,
      meta: {
        // isAuth: true,
        title: '美课正式课-美课教育'
      }
    }
  ]
})

// 使用meta
router1.beforeEach((to, from, next) => {
  // 如果是手机端
  if (navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )) {
    // 首页跳转
    if (to.path.indexOf('/') !== -1) {
      window.location.href="https://m.meikesheji.com"
    }
    // 直播间跳转
    if (to.path.indexOf('/live') !== -1) {
      window.location.href="https://m.meikesheji.com/#/live"
    }
  }
  // if (to.path !== '/login') {
  //   if (getCookie() !== undefined) {
  //     //  放行
  //     next()
  //   } else {
  //     Vue.prototype.$message.info('您还未登录,请先登录')
  //     next('/login')
  //   }
  // } else {
  //   //  放行
  //   next()
  // }
   next()
})

export default router1



// WEBPACK FOOTER //
// ./src/router/index.js